import { Container, Row, Col, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Btn } from 'AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CategoryProgramContain from './CategoryProgramContain';
import { resetState } from 'Features/Learning/CategoryProgram/addCategoryProgramSlice';

const CategoryProgramContainer = () => {
  const dispatch = useDispatch();
  const cards = useSelector(state => state.CategoryProgram.data.data)

  const handleAdd = () => {
    dispatch(resetState());
  };

  return (
    <Container fluid={true}>
      <Col md="12" className="project-list">
        {cards && (
          <Card>
            <Row>
              <Col>
                <Link to={`${process.env.PUBLIC_URL}/category-program/add`} onClick={handleAdd}>
                  <Btn attrBtn={{ color: 'primary' }}>
                    <i className="fa fa-plus-circle fa-lg"></i> Tambah Category Program
                  </Btn>
                </Link>
              </Col>
            </Row>
          </Card>
        )}
      </Col>
      <Row className='learning-block'>
        <Col xl="9" className='xl-80'>
          <Row>
            <CategoryProgramContain />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
export default CategoryProgramContainer;